module.exports = __webpack_public_path__ + "static/media/leftSection.abbcc1e6.webp";